/*eslint-disable multiline-ternary */
/*eslint-disable react/jsx-no-duplicate-props */
/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Form, Table } from 'react-bootstrap';
import '../Registrationsetup.scss';
import GetAdminConfiguration from '../../../api/GetAdminConfig';
import UserDefinedLabels from '../../../utils/UserDefinedLabels';

const FindMyAccount = (props) => {
  const iIndex = props.iIndex;
  const hasEditPermission = props.hasEditPermission;
  const personalIdentificationEditable = props.personalIdentificationEditable;
  const memberMinField = props.memberMinField;
  const dependentMinField = props.dependentMinField;
  const [minFieldMatch, setMinFieldMatch] = useState(
    GetAdminConfiguration.NumberOfItemsToMatch[iIndex],
  );
  const { CertificateNumberLabel, AlternateID1Label, AlternateID2Label } =
    UserDefinedLabels();

  //minFieldMatch is separate for member and dependent
  //this.handleInputChange = this.handleInputChange.bind(this); // the form control input box will not work if you don't bind
  const [state, setState] = React.useState({
    firstname:
      GetAdminConfiguration.FirstName[iIndex] == 'Visible' ||
      GetAdminConfiguration.FirstName[iIndex] == 'Required'
        ? true
        : false,
    lastname:
      GetAdminConfiguration.LastName[iIndex] == 'Visible' ||
      GetAdminConfiguration.LastName[iIndex] == 'Required'
        ? true
        : false,
    email:
      GetAdminConfiguration.Email[iIndex] == 'Visible' ||
      GetAdminConfiguration.Email[iIndex] == 'Required'
        ? true
        : false,
    dob:
      GetAdminConfiguration.DateOfBirth[iIndex] == 'Visible' ||
      GetAdminConfiguration.DateOfBirth[iIndex] == 'Required'
        ? true
        : false,
    addressline1:
      GetAdminConfiguration.AddressLine1[iIndex] == 'Visible' ||
      GetAdminConfiguration.AddressLine1[iIndex] == 'Required'
        ? true
        : false,
    addressline2:
      GetAdminConfiguration.AddressLine2[iIndex] == 'Visible' ||
      GetAdminConfiguration.AddressLine2[iIndex] == 'Required'
        ? true
        : false,
    city:
      GetAdminConfiguration.City[iIndex] == 'Visible' ||
      GetAdminConfiguration.City[iIndex] == 'Required'
        ? true
        : false,
    statename:
      GetAdminConfiguration.State[iIndex] == 'Visible' ||
      GetAdminConfiguration.State[iIndex] == 'Required'
        ? true
        : false,
    zipcode:
      GetAdminConfiguration.PostalCode[iIndex] == 'Visible' ||
      GetAdminConfiguration.PostalCode[iIndex] == 'Required'
        ? true
        : false,
    relationship:
      GetAdminConfiguration.Relationship[iIndex] == 'Visible' ||
      GetAdminConfiguration.Relationship[iIndex] == 'Required'
        ? true
        : false,
    phonenumber:
      GetAdminConfiguration.PhoneNumber[iIndex] == 'Visible' ||
      GetAdminConfiguration.PhoneNumber[iIndex] == 'Required'
        ? true
        : false,
    clientid:
      GetAdminConfiguration.ClientID[iIndex] == 'Visible' ||
      GetAdminConfiguration.ClientID[iIndex] == 'Required'
        ? true
        : false,
    clientname:
      GetAdminConfiguration.ClientName[iIndex] == 'Visible' ||
      GetAdminConfiguration.ClientName[iIndex] == 'Required'
        ? true
        : false,
    /*planid: ( GetAdminConfiguration.PlanID[ iIndex ] == 'Visible'
      || GetAdminConfiguration.PlanID[ iIndex ] == 'Required' ) ? true : false,*/
    ssn:
      GetAdminConfiguration.SSN[iIndex] == 'Visible' ||
      GetAdminConfiguration.SSN[iIndex] == 'Required'
        ? true
        : false,
    certno:
      GetAdminConfiguration.CertificateNumber[iIndex] == 'Visible' ||
      GetAdminConfiguration.CertificateNumber[iIndex] == 'Required'
        ? true
        : false,
    altid1:
      GetAdminConfiguration.AlternateID1[iIndex] == 'Visible' ||
      GetAdminConfiguration.AlternateID1[iIndex] == 'Required'
        ? true
        : false,
    altid2:
      GetAdminConfiguration.AlternateID2[iIndex] == 'Visible' ||
      GetAdminConfiguration.AlternateID2[iIndex] == 'Required'
        ? true
        : false,
    medicareid:
      GetAdminConfiguration.MedicareID[iIndex] == 'Visible' ||
      GetAdminConfiguration.MedicareID[iIndex] == 'Required'
        ? true
        : false,
    //Select option
    firstnameOption:
      GetAdminConfiguration.FirstName[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
    lastnameOption:
      GetAdminConfiguration.LastName[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
    emailOption:
      GetAdminConfiguration.Email[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
    dobOption:
      GetAdminConfiguration.DateOfBirth[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
    addressline1Option:
      GetAdminConfiguration.AddressLine1[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
    addressline2Option:
      GetAdminConfiguration.AddressLine2[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
    cityOption:
      GetAdminConfiguration.City[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
    statenameOption:
      GetAdminConfiguration.State[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
    zipcodeOption:
      GetAdminConfiguration.PostalCode[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
    relationshipOption:
      GetAdminConfiguration.Relationship[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
    phonenumberOption:
      GetAdminConfiguration.PhoneNumber[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
    clientidOption:
      GetAdminConfiguration.ClientID[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
    clientnameOption:
      GetAdminConfiguration.ClientName[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
    //planidOption: GetAdminConfiguration.PlanID[ iIndex ] == 'Required' ? 'Required' : 'Optional',
    ssnOption:
      GetAdminConfiguration.SSN[iIndex] == 'Required' ? 'Required' : 'Optional',
    certnoOption:
      GetAdminConfiguration.CertificateNumber[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
    altid1Option:
      GetAdminConfiguration.AlternateID1[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
    altid2Option:
      GetAdminConfiguration.AlternateID2[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
    medicareidOption:
      GetAdminConfiguration.MedicareID[iIndex] == 'Required'
        ? 'Required'
        : 'Optional',
  });

  const {
    firstname,
    lastname,
    email,
    dob,
    addressline1,
    addressline2,
    city,
    statename,
    zipcode,
    relationship,
    phonenumber,
    clientid,
    clientname,
    //planid,
    ssn,
    certno,
    altid1,
    altid2,
    medicareid,
    firstnameOption,
    lastnameOption,
    emailOption,
    dobOption,
    addressline1Option,
    addressline2Option,
    cityOption,
    statenameOption,
    zipcodeOption,
    relationshipOption,
    phonenumberOption,
    clientidOption,
    clientnameOption,
    //planidOption,
    ssnOption,
    certnoOption,
    altid1Option,
    altid2Option,
    medicareidOption,
  } = state;

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const handleOptionChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const handleInputChange = (event) => {
    setMinFieldMatch(event.target.value);
    GetAdminConfiguration.NumberOfItemsToMatch[iIndex] = event.target.value;
  };

  /*********************************************************************************************/
  //useEffect( () => {
  console.log('state.firstnameOption: ', state.firstnameOption);
  console.log('state.firstname: ', state.firstname);
  if (state.firstname && state.firstnameOption == 'Required')
    GetAdminConfiguration.FirstName[iIndex] = 'Required';
  else {
    if (state.firstname) GetAdminConfiguration.FirstName[iIndex] = 'Visible';
    else GetAdminConfiguration.FirstName[iIndex] = 'Invisible';
  }
  //GetAdminConfiguration.FirstName[iIndex] = (state.firstnameOption == 'Required' ? 'Required' : state.firstname == true ? 'Visible' : 'Invisible');
  console.log(
    'GetAdminConfiguration.FirstName[iIndex]: ',
    GetAdminConfiguration.FirstName[iIndex],
  );
  //}, [ iIndex, state.firstname, state.firstnameOption ] );

  //useEffect( () => {
  if (state.lastname && state.lastnameOption == 'Required')
    GetAdminConfiguration.LastName[iIndex] = 'Required';
  else {
    if (state.lastname) GetAdminConfiguration.LastName[iIndex] = 'Visible';
    else GetAdminConfiguration.LastName[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.LastName[iIndex]: ',
    GetAdminConfiguration.LastName[iIndex],
  );
  //GetAdminConfiguration.LastName[iIndex] = state.lastnameOption == 'Required' ? 'Required' : state.lastname == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.lastname, state.lastnameOption ] );

  //useEffect( () => {
  if (state.email && state.emailOption == 'Required')
    GetAdminConfiguration.Email[iIndex] = 'Required';
  else {
    if (state.email) GetAdminConfiguration.Email[iIndex] = 'Visible';
    else GetAdminConfiguration.Email[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.Email[iIndex]: ',
    GetAdminConfiguration.Email[iIndex],
  );
  //GetAdminConfiguration.Email[iIndex] = state.emailOption == 'Required' ? 'Required' : state.email == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.email, state.emailOption ] );

  //useEffect( () => {
  if (state.dob && state.dobOption == 'Required')
    GetAdminConfiguration.DateOfBirth[iIndex] = 'Required';
  else {
    if (state.dob) GetAdminConfiguration.DateOfBirth[iIndex] = 'Visible';
    else GetAdminConfiguration.DateOfBirth[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.DateOfBirth[iIndex]: ',
    GetAdminConfiguration.DateOfBirth[iIndex],
  );
  //GetAdminConfiguration.DateOfBirth[iIndex] = state.dobOption == 'Required' ? 'Required' : state.dob == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.dob, state.dobOption ] );

  //useEffect( () => {
  if (state.addressline1 && state.addressline1Option == 'Required')
    GetAdminConfiguration.AddressLine1[iIndex] = 'Required';
  else {
    if (state.addressline1)
      GetAdminConfiguration.AddressLine1[iIndex] = 'Visible';
    else GetAdminConfiguration.AddressLine1[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.AddressLine1[iIndex]: ',
    GetAdminConfiguration.AddressLine1[iIndex],
  );
  //GetAdminConfiguration.AddressLine1[iIndex] = state.addressline1Option == 'Required' ? 'Required' : state.addressline1 == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.addressline1, state.addressline1Option ] );

  //useEffect( () => {
  if (state.addressline2 && state.addressline2Option == 'Required')
    GetAdminConfiguration.AddressLine2[iIndex] = 'Required';
  else {
    if (state.addressline2)
      GetAdminConfiguration.AddressLine2[iIndex] = 'Visible';
    else GetAdminConfiguration.AddressLine2[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.AddressLine2[iIndex]: ',
    GetAdminConfiguration.AddressLine2[iIndex],
  );
  //GetAdminConfiguration.AddressLine2[iIndex] = state.addressline2Option == 'Required' ? 'Required' : state.addressline2 == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.addressline2, state.addressline2Option ] );

  //useEffect( () => {
  if (state.city && state.cityOption == 'Required')
    GetAdminConfiguration.City[iIndex] = 'Required';
  else {
    if (state.city) GetAdminConfiguration.City[iIndex] = 'Visible';
    else GetAdminConfiguration.City[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.City[iIndex]: ',
    GetAdminConfiguration.City[iIndex],
  );
  //GetAdminConfiguration.City[iIndex] = state.cityOption == 'Required' ? 'Required' : state.city == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.city, state.cityOption ] );

  //useEffect( () => {
  if (state.statename && state.statenameOption == 'Required')
    GetAdminConfiguration.State[iIndex] = 'Required';
  else {
    if (state.statename) GetAdminConfiguration.State[iIndex] = 'Visible';
    else GetAdminConfiguration.State[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.State[iIndex]: ',
    GetAdminConfiguration.State[iIndex],
  );
  //GetAdminConfiguration.State[iIndex] = state.statenameOption == 'Required' ? 'Required' : state.statename == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.statename, state.statenameOption ] );

  //useEffect( () => {
  if (state.zipcode && state.zipcodeOption == 'Required')
    GetAdminConfiguration.PostalCode[iIndex] = 'Required';
  else {
    if (state.zipcode) GetAdminConfiguration.PostalCode[iIndex] = 'Visible';
    else GetAdminConfiguration.PostalCode[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.PostalCode[iIndex]: ',
    GetAdminConfiguration.PostalCode[iIndex],
  );
  //GetAdminConfiguration.PostalCode[iIndex] = state.zipcodeOption == 'Required' ? 'Required' : state.zipcode == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.zipcode, state.zipcodeOption ] );

  //useEffect( () => {
  if (state.relationship && state.relationshipOption == 'Required')
    GetAdminConfiguration.Relationship[iIndex] = 'Required';
  else {
    if (state.relationship)
      GetAdminConfiguration.Relationship[iIndex] = 'Visible';
    else GetAdminConfiguration.Relationship[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.Relationship[iIndex]: ',
    GetAdminConfiguration.Relationship[iIndex],
  );
  //GetAdminConfiguration.Relationship[iIndex] = state.relationshipOption == 'Required' ? 'Required' : state.relationship == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.relationship, state.relationshipOption ] );

  //useEffect( () => {
  if (state.phonenumber && state.phonenumberOption == 'Required')
    GetAdminConfiguration.PhoneNumber[iIndex] = 'Required';
  else {
    if (state.phonenumber)
      GetAdminConfiguration.PhoneNumber[iIndex] = 'Visible';
    else GetAdminConfiguration.PhoneNumber[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.PhoneNumber[iIndex]: ',
    GetAdminConfiguration.PhoneNumber[iIndex],
  );
  //GetAdminConfiguration.PhoneNumber[iIndex] = state.phonenumberOption == 'Required' ? 'Required' : state.phonenumber == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.phonenumber, state.phonenumberOption ] );

  //useEffect( () => {
  if (state.clientid && state.clientidOption == 'Required')
    GetAdminConfiguration.ClientID[iIndex] = 'Required';
  else {
    if (state.clientid) GetAdminConfiguration.ClientID[iIndex] = 'Visible';
    else GetAdminConfiguration.ClientID[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.ClientID[iIndex]: ',
    GetAdminConfiguration.ClientID[iIndex],
  );
  //GetAdminConfiguration.ClientID[iIndex] = state.clientidOption == 'Required' ? 'Required' : state.clientid == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.clientid, state.clientidOption ] );

  //useEffect( () => {
  if (state.clientname && state.clientnameOption == 'Required')
    GetAdminConfiguration.ClientName[iIndex] = 'Required';
  else {
    if (state.clientname) GetAdminConfiguration.ClientName[iIndex] = 'Visible';
    else GetAdminConfiguration.ClientName[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.ClientName[iIndex]: ',
    GetAdminConfiguration.ClientName[iIndex],
  );
  //GetAdminConfiguration.ClientName[iIndex] = state.clientnameOption == 'Required' ? 'Required' : state.clientname == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.clientname, state.clientnameOption ] );

  //useEffect( () => {
  if (state.ssn && state.ssnOption == 'Required')
    GetAdminConfiguration.SSN[iIndex] = 'Required';
  else {
    if (state.ssn) GetAdminConfiguration.SSN[iIndex] = 'Visible';
    else GetAdminConfiguration.SSN[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.SSN[iIndex]: ',
    GetAdminConfiguration.SSN[iIndex],
  );
  //GetAdminConfiguration.SSN[iIndex] = state.ssnOption == 'Required' ? 'Required' : state.ssn == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.ssn, state.ssnOption ] );

  //useEffect( () => {
  if (state.certno && state.certnoOption == 'Required')
    GetAdminConfiguration.CertificateNumber[iIndex] = 'Required';
  else {
    if (state.certno)
      GetAdminConfiguration.CertificateNumber[iIndex] = 'Visible';
    else GetAdminConfiguration.CertificateNumber[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.CertificateNumber[iIndex]: ',
    GetAdminConfiguration.CertificateNumber[iIndex],
  );
  //GetAdminConfiguration.CertificateNumber[iIndex] = state.certnoOption == 'Required' ? 'Required' : state.certno == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.certno, state.certnoOption ] );

  //useEffect( () => {
  if (state.altid1 && state.altid1Option == 'Required')
    GetAdminConfiguration.AlternateID1[iIndex] = 'Required';
  else {
    if (state.altid1) GetAdminConfiguration.AlternateID1[iIndex] = 'Visible';
    else GetAdminConfiguration.AlternateID1[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.AlternateID1[iIndex]: ',
    GetAdminConfiguration.AlternateID1[iIndex],
  );
  //GetAdminConfiguration.AlternateID1[iIndex] = state.altid1Option == 'Required' ? 'Required' : state.altid1 == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.altid1, state.altid1Option ] );

  //useEffect( () => {
  if (state.altid2 && state.altid2Option == 'Required')
    GetAdminConfiguration.AlternateID2[iIndex] = 'Required';
  else {
    if (state.altid2) GetAdminConfiguration.AlternateID2[iIndex] = 'Visible';
    else GetAdminConfiguration.AlternateID2[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.AlternateID2[iIndex]: ',
    GetAdminConfiguration.AlternateID2[iIndex],
  );
  //GetAdminConfiguration.AlternateID2[iIndex] = state.altid2Option == 'Required' ? 'Required' : state.altid2 == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.altid2, state.altid2Option ] );

  //useEffect( () => {
  if (state.medicareid && state.medicareidOption == 'Required')
    GetAdminConfiguration.MedicareID[iIndex] = 'Required';
  else {
    if (state.medicareid) GetAdminConfiguration.MedicareID[iIndex] = 'Visible';
    else GetAdminConfiguration.MedicareID[iIndex] = 'Invisible';
  }
  console.log(
    'GetAdminConfiguration.MedicareID[iIndex]: ',
    GetAdminConfiguration.MedicareID[iIndex],
  );
  //GetAdminConfiguration.MedicareID[iIndex] = state.medicareidOption == 'Required' ? 'Required' : state.medicareid == true ? 'Visible' : 'Invisible';
  //}, [ iIndex, state.medicareid, state.medicareidOption ] );
  /*********************************************************************************************/

  return (
    <div className="personal-identification">
      <Form.Group controlId="formBasicminFieldMatch1">
        <Form.Label className="reg-lable" for="minFieldMatch">
          Minimum field(s) to match the record in “Find My Account” option.
        </Form.Label>
        <br></br>
        <input
          value={minFieldMatch}
          onChange={handleInputChange}
          //placeholder="5"
          type="text"
          id="minFieldMatch"
          name={`minFieldMatch${iIndex}`}
          disabled={!personalIdentificationEditable || !hasEditPermission}
          required
          className={
            memberMinField && iIndex === 2
              ? 'errorValidateInput'
              : dependentMinField && iIndex === 5
              ? 'errorValidateInput'
              : ''
          }
        />
        {/*<Form.Control
          type="text"
          placeholder="5"
          value={minFieldMatch}
          onChange={handleInputChange}
          //ref={minFieldMatch}
          name="minFieldMatch"/> */}
      </Form.Group>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th style={{ textAlign: 'center' }}>Publish</th>
            <th style={{ textAlign: 'center' }}>Field</th>
            <th style={{ textAlign: 'center' }}>Required</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Form.Group
                controlId="formGridCheckfirs1"
                className="disabled-fields"
              >
                <Form.Label className="sr-only" for="firstnameFind">
                  firstname
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={true}
                  //onChange={handleChange}
                  id="firstnameFind"
                  name="firstname"
                  disabled={true}
                  isDisabled={true}
                  className={'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>First Name</td>
            <td>
              <Form.Group
                controlId="exampleForm.firstnameOption"
                className="disabled-fields"
              >
                <Form.Control
                  as="select"
                  disabled={true}
                  //onChange={handleOptionChange}
                  name="firstnameOption"
                  value={'Required'}
                  data-mystatus="disabled-data"
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridLast" className="disabled-fields">
                <Form.Label className="sr-only" for="lastname">
                  lastname
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={true}
                  //onChange={handleChange}
                  id="lastname"
                  name="lastname"
                  disabled={true}
                  isDisabled={true}
                  className={'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Last Name</td>
            <td>
              <Form.Group
                controlId="exampleForm.lastnameOption"
                className="disabled-fields"
              >
                <Form.Control
                  as="select"
                  disabled={true}
                  //onChange={handleOptionChange}
                  name="lastnameOption"
                  value={'Required'}
                  data-mystatus="disabled-data"
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>
          {/*<tr>
            <td>
              <Form.Group controlId="formGridemailfind">
                <Form.Label className="sr-only" for="email">
                  email
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={email}
                  id="email"
                  onChange={handleChange}
                  name="email"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Email</td>
            <td>
              <Form.Group controlId="exampleForm.emailOption">
                <Form.Control
                  as="select"
                  disabled={
                    !email ||
                    !personalIdentificationEditable ||
                    !hasEditPermission
                  }
                  onChange={handleOptionChange}
                  name="emailOption"
                  value={emailOption}
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>*/}
          <tr>
            <td>
              <Form.Group controlId="formGridChdob" className="disabled-fields">
                <Form.Label className="sr-only" for="dob">
                  dob
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={true}
                  //onChange={handleChange}
                  id="dob"
                  name="dob"
                  disabled={true}
                  isDisabled={true}
                  className={'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Date of Birth</td>
            <td>
              <Form.Group
                controlId="exampleForm.dobOption"
                className="disabled-fields"
              >
                <Form.Control
                  as="select"
                  disabled={true}
                  //onChange={handleOptionChange}
                  name="dobOption"
                  value={'Required'}
                  data-mystatus="disabled-data"
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridChaddressline1">
                <Form.Label className="sr-only" for="addressline1">
                  addressline1
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={addressline1}
                  onChange={handleChange}
                  id="addressline1"
                  name="addressline1"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Address Line 1</td>
            <td>
              <Form.Group controlId="exampleForm.addressline1Option">
                <Form.Control
                  as="select"
                  disabled={
                    !addressline1 ||
                    !personalIdentificationEditable ||
                    !hasEditPermission
                  }
                  onChange={handleOptionChange}
                  name="addressline1Option"
                  value={addressline1Option}
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridCaddressline2">
                <Form.Label className="sr-only" for="addressline22">
                  addressline2
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={addressline2}
                  id="addressline22"
                  onChange={handleChange}
                  name="addressline2"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Address Line 2</td>
            <td>
              <Form.Group controlId="exampleForm.addressline2Option">
                <Form.Control
                  as="select"
                  disabled={
                    !addressline2 ||
                    !personalIdentificationEditable ||
                    !hasEditPermission
                  }
                  onChange={handleOptionChange}
                  name="addressline2Option"
                  value={addressline2Option}
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridChcity">
                <Form.Label className="sr-only" for="city">
                  city
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={city}
                  id="city"
                  onChange={handleChange}
                  name="city"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>City</td>
            <td>
              <Form.Group controlId="exampleForm.cityOption">
                <Form.Control
                  as="select"
                  disabled={
                    !city ||
                    !personalIdentificationEditable ||
                    !hasEditPermission
                  }
                  onChange={handleOptionChange}
                  name="cityOption"
                  value={cityOption}
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridChstatename">
                <Form.Label className="sr-only" for="statename">
                  statename
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={statename}
                  id="statename"
                  onChange={handleChange}
                  name="statename"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>State</td>
            <td>
              <Form.Group controlId="exampleForm.statenameOption">
                <Form.Control
                  as="select"
                  disabled={
                    !statename ||
                    !personalIdentificationEditable ||
                    !hasEditPermission
                  }
                  onChange={handleOptionChange}
                  name="statenameOption"
                  value={statenameOption}
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridChzipcode">
                <Form.Label className="sr-only" for="zipcode">
                  zipcode
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={zipcode}
                  id="zipcode"
                  onChange={handleChange}
                  name="zipcode"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Postal Code</td>
            <td>
              <Form.Group controlId="exampleForm.zipcodeOption">
                <Form.Control
                  as="select"
                  disabled={
                    !zipcode ||
                    !personalIdentificationEditable ||
                    !hasEditPermission
                  }
                  onChange={handleOptionChange}
                  name="zipcodeOption"
                  value={zipcodeOption}
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>
          {GetAdminConfiguration.MemberType[iIndex] != 'Employee' && (
            <tr>
              <td>
                <Form.Group controlId="formGridCherelationship">
                  <Form.Label className="sr-only" for="relationship">
                    relationship
                  </Form.Label>
                  <Form.Check
                    type="checkbox"
                    checked={relationship}
                    onChange={handleChange}
                    id="relationship"
                    name="relationship"
                    disabled={
                      !personalIdentificationEditable || !hasEditPermission
                    }
                    isDisabled={!hasEditPermission}
                    className={!hasEditPermission && 'disabled-checkbox'}
                  />
                </Form.Group>
              </td>
              <td>Relationship</td>
              <td>
                <Form.Group controlId="exampleForm.relationshipOption">
                  <Form.Control
                    as="select"
                    disabled={
                      !relationship ||
                      !personalIdentificationEditable ||
                      !hasEditPermission
                    }
                    onChange={handleOptionChange}
                    name="relationshipOption"
                    value={relationshipOption}
                  >
                    <option>Required</option>
                    <option>Optional</option>
                  </Form.Control>
                </Form.Group>
              </td>
            </tr>
          )}
          <tr>
            <td>
              <Form.Group controlId="formGridChphonenumber">
                <Form.Label className="sr-only" for="phonenumber">
                  phonenumber
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={phonenumber}
                  onChange={handleChange}
                  id="phonenumber"
                  name="phonenumber"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Phone Number</td>
            <td>
              <Form.Group controlId="exampleForm.phonenumberOption">
                <Form.Control
                  as="select"
                  disabled={
                    !phonenumber ||
                    !personalIdentificationEditable ||
                    !hasEditPermission
                  }
                  onChange={handleOptionChange}
                  name="phonenumberOption"
                  value={phonenumberOption}
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridChclientid">
                <Form.Label className="sr-only" for="clientid">
                  clientid
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={clientid}
                  id="clientid"
                  onChange={handleChange}
                  name="clientid"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Client ID</td>
            <td>
              <Form.Group controlId="exampleForm.clientidOption">
                <Form.Control
                  as="select"
                  disabled={
                    !clientid ||
                    !personalIdentificationEditable ||
                    !hasEditPermission
                  }
                  onChange={handleOptionChange}
                  name="clientidOption"
                  value={clientidOption}
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridChclientname">
                <Form.Label className="sr-only" for="clientname">
                  clientname
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={clientname}
                  id="clientname"
                  onChange={handleChange}
                  name="clientname"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Client Name</td>
            <td>
              <Form.Group controlId="exampleForm.clientnameOption">
                <Form.Control
                  as="select"
                  disabled={
                    !clientname ||
                    !personalIdentificationEditable ||
                    !hasEditPermission
                  }
                  onChange={handleOptionChange}
                  name="clientnameOption"
                  value={clientnameOption}
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>

          <tr>
            <td>
              <Form.Group controlId="formGridChssn" className="disabled-fields">
                <Form.Label className="sr-only" for="ssn">
                  ssn
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={true}
                  id="ssn"
                  //onChange={handleChange}
                  name="ssn"
                  disabled={true}
                  isDisabled={true}
                  className={'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>SSN</td>
            <td>
              <Form.Group
                controlId="exampleForm.ssnOption"
                className="disabled-fields"
              >
                <Form.Control
                  as="select"
                  disabled={true}
                  //onChange={handleOptionChange}
                  name="ssnOption"
                  value={'Required'}
                  data-mystatus="disabled-data"
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridcertno">
                <Form.Label className="sr-only" for="certno">
                  certno
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={certno}
                  onChange={handleChange}
                  id="certno"
                  name="certno"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>{CertificateNumberLabel}</td>
            <td>
              <Form.Group controlId="exampleForm.certnoOption">
                <Form.Control
                  as="select"
                  disabled={
                    !certno ||
                    !personalIdentificationEditable ||
                    !hasEditPermission
                  }
                  onChange={handleOptionChange}
                  name="certnoOption"
                  value={certnoOption}
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>
          <tr>
            <td>
              <Form.Group
                controlId="formGridChaltid1"
                className="disabled-fields"
              >
                <Form.Label className="sr-only" for="altid1">
                  altid1
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={true}
                  //onChange={handleChange}
                  id="altid1"
                  name="altid1"
                  disabled={true}
                  isDisabled={true}
                  className={'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>{AlternateID1Label}</td>
            <td>
              <Form.Group
                controlId="exampleForm.altid1Option"
                className="disabled-fields"
              >
                <Form.Control
                  as="select"
                  disabled={true}
                  //onChange={handleOptionChange}
                  name="altid1Option"
                  value={'Required'}
                  data-mystatus="disabled-data"
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridChaltid2">
                <Form.Label className="sr-only" for="altid2">
                  altid2
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={altid2}
                  id="altid2"
                  onChange={handleChange}
                  name="altid2"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>{AlternateID2Label}</td>
            <td>
              <Form.Group controlId="exampleForm.altid2Option">
                <Form.Control
                  as="select"
                  disabled={
                    !altid2 ||
                    !personalIdentificationEditable ||
                    !hasEditPermission
                  }
                  onChange={handleOptionChange}
                  name="altid2Option"
                  value={altid2Option}
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>
          <tr>
            <td>
              <Form.Group controlId="formGridChmedicareid">
                <Form.Label className="sr-only" for="medicareid">
                  medicareid
                </Form.Label>
                <Form.Check
                  type="checkbox"
                  checked={medicareid}
                  onChange={handleChange}
                  id="medicareid"
                  name="medicareid"
                  disabled={
                    !personalIdentificationEditable || !hasEditPermission
                  }
                  isDisabled={!hasEditPermission}
                  className={!hasEditPermission && 'disabled-checkbox'}
                />
              </Form.Group>
            </td>
            <td>Medicare ID</td>
            <td>
              <Form.Group controlId="exampleForm.medicareidOption">
                <Form.Control
                  as="select"
                  disabled={
                    !medicareid ||
                    !personalIdentificationEditable ||
                    !hasEditPermission
                  }
                  onChange={handleOptionChange}
                  name="medicareidOption"
                  value={medicareidOption}
                >
                  <option>Required</option>
                  <option>Optional</option>
                </Form.Control>
              </Form.Group>
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default FindMyAccount;
